const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M8.2 4.73a.75.75 0 0 0-1.4 0l-5 13a.75.75 0 1 0 1.4.54l1.161-3.02h6.278l1.161 3.02a.75.75 0 1 0 1.4-.54zm1.862 9.02L7.5 7.09l-2.562 6.66zM20.25 12a3.75 3.75 0 1 0 0 6 .75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1.5 0m-2.25.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5" clip-rule="evenodd"/></svg>';
export {
  e as w
};
